export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "name": "Руководитель в переговорах — как руководителю добиваться результата",
        "description": "Руководитель в переговорах: влияние, аргументация, отстаивание позиции, сложные переговоры с сотрудниками, руководством, клиентами и партнёрами. Практическое корпоративное обучение.",
        "url": "https://business-training.by/menedzhment-i-liderstvo/rukovoditel-v-peregovorah",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Business Training",
          "url": "https://business-training.by"
        }
      },
      {
        "@type": "Service",
        "name": "Обучение руководителей навыкам переговоров",
        "description": "Корпоративное обучение руководителей и управленческих команд переговорным навыкам: подготовка, аргументация, влияние, удержание позиции, работа с уступками и фиксация договорённостей в переговорах с сотрудниками, сильными специалистами, собственниками, руководством, клиентами и партнёрами.",
        "provider": {
          "@type": "Person",
          "name": "Алексей Сивко",
          "jobTitle": "Бизнес-тренер, консультант, фасилитатор, сертифицированный коуч ICU",
          "url": "https://business-training.by/o-trenere",
          "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
        },
        "areaServed": [
          { "@type": "Country", "name": "Беларусь" },
          { "@type": "Country", "name": "Россия" },
          { "@type": "Country", "name": "Казахстан" },
          { "@type": "Country", "name": "Израиль" }
        ],
        "serviceType": "обучение руководителей переговорам, переговоры руководителя, навыки руководителя в переговорах, развитие управленческих компетенций",
        "url": "https://business-training.by/menedzhment-i-liderstvo/rukovoditel-v-peregovorah"
      },
      {
        "@type": "Person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер",
        "description": "18+ лет практики в корпоративном обучении. 100+ корпоративных проектов, 450+ тренингов и бизнес-сессий, 4500+ участников. Средняя оценка участников — 9,09/10. Работал с компаниями Беларуси, России, Казахстана и Израиля.",
        "url": "https://business-training.by/o-trenere",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Что должен уметь руководитель в переговорах?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Руководитель должен уметь готовиться к переговорам, ясно формулировать позицию, выявлять интересы другой стороны, аргументировать свою точку зрения фактами и целями бизнеса, работать с возражениями и давлением, удерживать принципиальные позиции, управлять уступками и переводить разговор в конкретные договорённости со сроками и критериями результата."
            }
          },
          {
            "@type": "Question",
            "name": "Чем переговоры руководителя отличаются от переговоров менеджера?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Менеджер чаще защищает интересы конкретной сделки, клиента или проекта. Руководитель одновременно учитывает интересы компании и команды, финансовый результат, долгосрочные отношения, риски, ответственность, репутацию и последствия решения. У руководителя выше цена ошибки, поэтому он должен видеть переговоры не только как способ получить уступку, но и как инструмент управления."
            }
          },
          {
            "@type": "Question",
            "name": "Как руководителю отстаивать свою позицию?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Начинать с подготовки: определить, какая позиция принципиальна, а где есть пространство для договорённости. Затем аргументировать позицию через факты, цели бизнеса и последствия альтернативных решений, а не через давление или эмоции. Важно удерживать принципиальные требования, не поддаваясь на манипуляции, и одновременно сохранять управляемость ситуации."
            }
          },
          {
            "@type": "Question",
            "name": "Как руководителю договариваться с сильными сотрудниками?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Сильного сотрудника нельзя просто «поставить на место» — это приведёт к потере мотивации или уходу. Нужно одновременно удерживать требования и сохранять отношения: понимать, что стоит за позицией сотрудника, отделять его реальный интерес от заявленного, искать решения, учитывающие и интересы бизнеса, и интересы сотрудника, и при этом ясно обозначать границы и ответственность."
            }
          },
          {
            "@type": "Question",
            "name": "Как вести переговоры с собственником?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "С собственником важно не просто высказать мнение, а сформировать позицию, аргументировать её цифрами и фактами и показать последствия альтернативных решений. Нужно говорить на языке результатов, ресурсов и рисков, заранее продумывать возможные возражения и предлагать варианты, а не только обозначать проблему."
            }
          },
          {
            "@type": "Question",
            "name": "Как руководителю реагировать на давление?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Алгоритм прост: остановиться, вернуть разговор к фактам, уточнить интересы другой стороны, обозначить свою позицию, определить границы допустимого, предложить варианты и зафиксировать договорённость. Главное — не поддаваться на эмоциональные реакции и манипуляции, сохранять рабочую позицию и контроль над собой."
            }
          },
          {
            "@type": "Question",
            "name": "Как не уступать слишком много в переговорах?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "До начала переговоров определить, какие позиции принципиальны, а где уступка допустима. Каждая уступка должна что-то давать взамен, а не быть односторонним движением. Важно не делать уступки под эмоциональным давлением или из желания быстрее закончить разговор, и не превращать переговоры в спор, где главное — доказать свою правоту."
            }
          },
          {
            "@type": "Question",
            "name": "Как руководителю добиваться выполнения договорённостей?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Договорённость должна быть конкретной: действие, срок и критерий результата, а не общее обещание. Важно, чтобы стороны одинаково понимали, о чём договорились, и зафиксировать это. Затем руководитель проверяет выполнение в контрольной точке и при нарушении возвращается к ответственности сотрудника, а не молча переделывает за него."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли обучить руководителей переговорам?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, переговорные навыки — это практический навык, который отрабатывается. На обучении руководители не просто слушают теорию, а тренируются на реальных ситуациях: ролевые переговоры, переговорные дуэли, разбор кейсов, отработка аргументации и удержания позиции под давлением."
            }
          },
          {
            "@type": "Question",
            "name": "Для каких руководителей подходит программа?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Программа подходит собственникам бизнеса, генеральным и коммерческим директорам, руководителям подразделений, РОПам, руководителям среднего звена, топ-менеджерам и руководителям проектов — всем, кому приходится лично участвовать в ключевых переговорах и отстаивать интересы бизнеса."
            }
          },
          {
            "@type": "Question",
            "name": "Сколько длится обучение?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Корпоративный тренинг обычно занимает 1–2 дня практической работы. Модульная программа может длиться несколько недель с практикой между модулями, а комплексная управленческая программа — несколько месяцев. Точный формат и продолжительность определяются после диагностики задач компании."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли адаптировать программу под конкретную компанию?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, адаптация — обязательный этап. Сначала мы разбираемся, с какими переговорными ситуациями реально сталкиваются руководители: сложные сотрудники, переговоры с собственником, защита бюджета, конфликты между подразделениями. После этого программа настраивается под уровень участников и специфику бизнеса."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли добавить сопровождение после тренинга?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да. После обучения при необходимости проводится сопровождение: разбираются реальные переговоры и сложные ситуации, возникшие в работе руководителей, корректируются действия и закрепляются навыки. При системной работе определяется, изменилось ли переговорное и управленческое поведение."
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}